module.exports = __webpack_public_path__ + "static/RTC360-70fa684cd282b13d436212671c0f575f.jpg";